<template>
  <div
    class="flex items-center py-2 text-base"
    :class="{
      'cursor-pointer': !readonly,
    }"
  >
    <span
      v-if="!readonly"
      class="flex h-4 w-4 shrink-0 items-center justify-center border-2 dir-ltr:mr-2 dir-rtl:ml-2"
      aria-hidden="true"
      :class="[
        selected
          ? 'border-transparent bg-theme-primary'
          : 'border-theme-primary/50 bg-theme-background',
        checkbox ? 'rounded-sm' : 'rounded-full',
      ]"
    >
      <span
        v-if="selected && !checkbox"
        class="h-1.5 w-1.5 rounded-full bg-theme-background"
      />
      <span v-if="selected && checkbox">
        <CheckFatFill class="h-3 w-3 text-theme-background" />
      </span>
    </span>
    <div class="flex-1 dir-ltr:pr-3 dir-rtl:pl-3">
      {{ name }}
    </div>
    <div class="flex items-baseline">
      <span class="whitespace-nowrap font-semibold text-theme-text">
        <template v-if="price && price > 0">
          {{ pricePlus ? '+' : '' }}{{ formatPrice(price) }}
        </template>
      </span>
      <span
        v-if="!pricePlus && oldPrice && oldPrice > 0"
        class="whitespace-nowrap text-[0.9em] font-medium text-theme-text/45 line-through ltr:ml-1.5 rtl:mr-1.5"
      >
        {{ formatPrice(oldPrice) }}
      </span>
    </div>
  </div>
</template>

<script setup lang="ts">
import CheckFatFill from '@/phosphoricons/CheckFatFill.vue';
import formatPrice from '@menu/Utils/formatPrice';

defineProps<{
  name?: string;
  price?: number | null;
  oldPrice?: number | null;
  checkbox?: boolean;
  pricePlus?: boolean;
  readonly?: boolean;
  selected?: boolean;
}>();
</script>
